module.exports = __webpack_public_path__ + "img/our-donors.d12ac61.svg";